import Mock from 'mockjs'

import mockHome from './home'
// 拦截请求
Mock.mock('/getData', mockHome)

